require('./stylesheets/shortLinks.scss');

angular.module('pages.shortLinks', [])
    .config(config);

config.$inject = ['$stateProvider'];

function config($stateProvider) {
    $stateProvider
        .state('pages.shortLinks', {
            url: 'l/{urlCode:[A-z0-9]{5,8}}',
            template: require('./templates/shortLinks.html'),
            controller: require('./controllers/shortLinks.controller.js'),
            data: {
                restricted: false,
                iframe: false
            },
            pageTrack: '/short-links'
        });
}

module.exports = 'pages.shortLinks';



/*****************
 ** WEBPACK FOOTER
 ** ./app/pages/shortLinks/index.js
 ** module id = 294
 ** module chunks = 1
 **/